import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import { carouselInfoType } from '@/components/Carousel/types';
import CarouselProvider from '@/components/Carousel/CarouselProvider';
import SlickCarousel from '@/components/Carousel/SlickCarousel';

export default function ProductCarouselVideo({
  OptionalHeader,
  cta,
  items,
  anchorLinkID,
  margin,
  centerText,
  overlaySrc,
}) {
  const formattedItems = items
    ? items.map(item => ({
        name: item.title,
        description: item.description,
        link: item.link ? item.link : null,
        videoSrc: item.videoSrc,
        posterSrc: item.posterSrc,
        overlaySrc,
      }))
    : [];

  const carouselInfo = {
    name: 'product-carousel',
    type: carouselInfoType.video,
  };
  return (
    <div {...getAnchorId(anchorLinkID)}>
      <CarouselProvider centerText={centerText}>
        <SlickCarousel
          optionalHeader={OptionalHeader}
          items={formattedItems}
          cta={cta}
          className={getComponentMargin(margin)}
          carouselInfo={carouselInfo}
        />
      </CarouselProvider>
    </div>
  );
}
